import axiosLib from 'axios'

import { getToken } from './cj-axios'

// Prod builds take .env.production from the BUILD_ENVS CI variable, which does
// not set REACT_APP_CJV3_API_HOST, so the prod host is the fallback.
const axios = axiosLib.create({
  baseURL: process?.env?.REACT_APP_CJV3_API_HOST || 'https://cjv3-be.kfm.kariba.ai/',
})

// Only Authorization: the cjv3-be ingress CORS allow-list rejects any other
// custom header (e.g. cj-axios's X-OneLife-Context).
axios.interceptors.request.use((request) => {
  request.headers.Authorization = getToken()
  return request
})

export default axios
